import styled from "styled-components";

// Main container
export const AppContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
  min-height: 80vh;

  @media (max-width: 1024px) {
    min-height: 70vh;
  }

  @media (max-width: 768px) {
    padding: 0.5rem;
    min-height: auto;
    margin: 1rem 0;
  }
`;

// Profile container
export const ProfileContainer = styled.div`
  display: flex;
  width: 55%;
  height: 55vh;
  background-color: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.08);
  font-family: "Noto Kufi Arabic", sans-serif;
  direction: rtl;
  overflow: hidden;

  @media (max-width: 1200px) {
    width: 70%;
    height: auto;
    min-height: 50vh;
  }

  @media (max-width: 900px) {
    width: 85%;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    width: 95%;
    height: auto;
    border-radius: 12px;
  }
`;

export const ProfileImageSection = styled.div`
  flex: 0 0 250px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);

  @media (max-width: 768px) {
    flex: none;
    padding: 1.5rem;
    width: 100%;
  }
`;

export const ProfileImageContainer = styled.div`
  width: 180px;
  height: 180px;
  border-radius: 50%;
  background-color: #e9ecef;
  border: 5px solid #fff;
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.1);
  margin-bottom: 1.5rem;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  @media (max-width: 768px) {
    width: 140px;
    height: 140px;
    margin-bottom: 1rem;
  }

  @media (max-width: 480px) {
    width: 120px;
    height: 120px;
  }
`;

export const ProfileAvatar = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const MainContent = styled.div`
  flex: 1;
  padding: 2rem;

  @media (max-width: 768px) {
    padding: 1.5rem;
  }

  @media (max-width: 480px) {
    padding: 1rem;
  }
`;

export const InfoCard = styled.div`
  background-color: #fff;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  border: 1px solid #f0f0f0;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    padding: 1.2rem;
    margin-bottom: 1.2rem;
  }

  @media (max-width: 480px) {
    padding: 1rem;
    margin-bottom: 1rem;
  }
`;

export const CardTitle = styled.h3`
  margin: 0 0 1.2rem 0;
  color: #2c3e50;
  font-size: 1.2rem;
  padding-bottom: 0.6rem;
  border-bottom: 1px solid #eee;
  font-weight: 600;

  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 1rem;
  }

  @media (max-width: 480px) {
    font-size: 1rem;
    margin-bottom: 0.8rem;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  margin-bottom: 0.8rem;

  @media (max-width: 768px) {
    flex-direction: column;
    margin-bottom: 0.6rem;
  }
`;

export const Label = styled.span`
  font-weight: bold;
  color: #444;
  min-width: 120px;
  font-size: 0.95rem;

  @media (max-width: 768px) {
    min-width: auto;
    margin-bottom: 0.2rem;
    font-size: 0.9rem;
  }
`;

export const Value = styled.span`
  color: #555;
  flex: 1;
  font-size: 0.95rem;

  @media (max-width: 768px) {
    font-size: 0.9rem;
    margin-right: 0.5rem;
  }
`;

export const StatusBadge = styled.span`
  display: inline-block;
  padding: 0.4rem 1rem;
  border-radius: 20px;
  font-size: 0.9rem;
  font-weight: bold;
  background-color: ${(props) =>
    props.isActive ? "rgba(46, 125, 50, 0.1)" : "rgba(198, 40, 40, 0.1)"};
  color: ${(props) => (props.isActive ? "#2e7d32" : "#c62828")};

  @media (max-width: 768px) {
    padding: 0.3rem 0.8rem;
    font-size: 0.85rem;
  }
`;

